import gql from 'graphql-tag'

export const INVITE_USER_TO_ORGANIZATION = gql`
  mutation inviteUserToOrganization(
    $organizationSlug: String!
    $inviteData: UserOrganizationInviteData!
  ) {
    inviteUserToOrganization(organizationSlug: $organizationSlug, inviteData: $inviteData)
  }
`

export const ACCEPT_INVITE = gql`
  mutation acceptInvite($token: String!) {
    acceptInvite(token: $token)
  }
`

export const RESEND_INVITE = gql`
  mutation resendInvite($organizationSlug: String!, $inviteId: Int!) {
    resendInvite(organizationSlug: $organizationSlug, inviteId: $inviteId)
  }
`

export const DELETE_INVITE = gql`
  mutation deleteInvite($organizationSlug: String!, $inviteId: Int!) {
    deleteInvite(organizationSlug: $organizationSlug, inviteId: $inviteId)
  }
`

export const GET_MY_PENDING_INVITES = gql`
  query myPendingInvites {
    myPendingInvites {
      id
      organizationRole
      token
      type
      organization {
        publicName
        logo
        slug
      }
    }
  }
`

export const REJECT_INVITE = gql`
  mutation rejectInvite($inviteId: Int!) {
    rejectInvite(inviteId: $inviteId)
  }
`
